import { Link } from '@tanstack/react-router'
import type { ComponentProps, ReactNode } from 'react'

/** Shared prose primitives for the company pages' reading column. */

export function ProseHeading({ children }: { children: ReactNode }) {
  return (
    <h2 className="text-sheen mb-4 pb-0.5 text-2xl font-semibold tracking-[-0.03em] md:text-3xl">
      {children}
    </h2>
  )
}

export function ProseParagraph({ children }: { children: ReactNode }) {
  return (
    <p className="text-lg leading-relaxed text-pretty text-[var(--color-text-secondary)]">
      {children}
    </p>
  )
}

const LINK_CLASS =
  'font-medium text-[var(--color-text-primary)] underline decoration-[var(--color-border-strong)] underline-offset-4 transition-colors duration-300 ease-brisk hover:decoration-primary'

export function ProseLink(props: ComponentProps<typeof Link>) {
  return <Link {...props} className={LINK_CLASS} />
}

export function ProseAnchor({
  href,
  children,
}: {
  href: string
  children: ReactNode
}) {
  return (
    <a href={href} className={LINK_CLASS}>
      {children}
    </a>
  )
}
